import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import MenuIcon from "@mui/icons-material/Menu";

const SidebarHeader = ({ open, handleDrawerToggle }) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: open ? "8px 16px" : "8px 10px",
                backgroundColor: "#fec335",
                color: "#fff",
            }}
        >
            <Typography
                variant="h6"
                noWrap
                sx={{ display: open ? "block" : "none" }}
            >
                Dashboard
            </Typography>
            <IconButton onClick={handleDrawerToggle} sx={{ color: "#fff" }}>
                {open ? <MenuOpenIcon /> : <MenuIcon />}
            </IconButton>
        </Box>
    );
};

export default SidebarHeader;
